/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { EntityAnyInsightsConfig } from '../../Services/insights';

/**
 * The event builder table id.
 * @export
 */
export const EVENT_BUILDER_TABLE_ID = `event-listing-attribute-table`;

/**
 * The event builder attributes id.
 * @export
 */
export const EVENT_BUILDER_ATTRIBUTES_ID = `event-builder-attributes`;

/**
 * The field ids used in the event builder data integration form.
 * @export
 */
export const EVENT_BUILDER_DATA_FORM_IDS = {
  collection: `event-builder-collection`,
  dataService: `event-builder-data-service`,
  name: `event-builder-name`,
  uniqueIdentifier: `event-builder-unique-identifier`,
};

/**
 * The field ids used in the event builder web behavior form.
 * @export
 */
export const EVENT_BUILDER_WEB_BEHAVIOR_FORM_IDS = {
  id: `event-builder-id`,
  name: `event-builder-name`,
  time: `event-time-period`,
  type: `event-type`,
  uniqueCustomId: `event-custom-id`,
};

export const EVENT_BUILDER_FORM_ID_PROPERTY_MAP = {
  [EVENT_BUILDER_DATA_FORM_IDS.collection]: `filter.collectionPrefix`,
  [EVENT_BUILDER_DATA_FORM_IDS.dataService]: `filter.datastoreURL`,
  [EVENT_BUILDER_DATA_FORM_IDS.name]: `name`,
  [EVENT_BUILDER_DATA_FORM_IDS.uniqueIdentifier]: `index.target`,
  [EVENT_BUILDER_WEB_BEHAVIOR_FORM_IDS.id]: `attributeid`,
  [EVENT_BUILDER_WEB_BEHAVIOR_FORM_IDS.name]: `name`,
  [EVENT_BUILDER_WEB_BEHAVIOR_FORM_IDS.time]: `relevance.value`,
  [EVENT_BUILDER_WEB_BEHAVIOR_FORM_IDS.type]: `type`,
  [EVENT_BUILDER_WEB_BEHAVIOR_FORM_IDS.uniqueCustomId]: `uniqueCustomId`,
};

/**
 * The data ids used in the toast messages for the event builder.
 * @export
 */
export const EVENT_BUILDER_DATA_IDS = {
  buttonSaveChanges: `Button: save changes`,
  eventBuilderAddAttribute: `Form field: Add attribute`,
  eventDetailsCollectionName: `Form field: Collection name`,
  eventDetailsDataService: `Form field: Data service`,
  eventDetailsName: `Form field: Event name`,
  eventUniqueIdentifier: `Form field: Unique identifier attribute`,
  toastFailCreate: `Toast: Fail event create`,
  toastSuccessCreate: `Toast: Success event create`,
};

/**
 * Empty datastore event data.
 */
export const EVENT_EMPTY: EntityAnyInsightsConfig = {
  eventType: `datastore`,
  filter: {
    collectionPrefix: ``,
    datastoreURL: ``,
  },
  index: {
    target: ``,
  },
  name: ``,
  properties: {
    [``]: ``,
  },
};
